module.exports = __webpack_public_path__ + "static/media/group.da82c98c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/group.jpg
// module id = 292
// module chunks = 0